<template>
	<div id="excel">
		<h4><b>Export Shipments</b></h4>
		<br>
		<b-row>
			<b-col cols="2">
				From Shipment Date:
			</b-col>
			<b-col cols="9">
				<b-input type="date" placeholder="mm/dd/yyyy" @change="onChangeStart" id="start"></b-input>
			</b-col>
		</b-row>
		<br>
		<b-row>
			<b-col cols="2">
				To Shipment Date:
			</b-col >
			<b-col cols="9">
				<b-input type="date" placeholder="mm/dd/yyyy" @change="onChangeEnd" id="end"></b-input>
			</b-col>
		</b-row>
		<br>
		
		<b-row>
			<b-col>
				<div v-if="json_data.length>0">
					<download-csv
					:data   = "json_data"
					name    = "shipments.csv">
					<b-button variant="primary" id="excelButton">Export Excel</b-button>
				</download-csv>
			</div>
			<div v-else>
				<p style="color:blue">Please select appropriate dates, the date range must contain shipment data for export button to appear</p>
			</div>
		</b-col>
	</b-row>
	<br>
	<hr>
	<h4><b>Import Shipments</b></h4>
	<div v-if="parseCsv===null">
		<p style="color:red">Warning! Do not, try to upload files that do not end with .csv</p>
		<vue-csv-import v-model="parseCsv" :map-fields="{'Species': 'Species', 'Common Name': 'Common Name',
		'Number Received': 'Number Received', 'Supplier':'Supplier', 'Shipment Date': 'Shipment Date',
		'Arrival Date': 'Arrival Date', 'Emerged in transit' : 'Emerged in transit', 'Damaged in transit': 'Damaged in transit',
		'Diseased':'Diseased', 'Parasites':'Parasites', 'No Emergence': 'No Emergence', 'Poor Emergence':'Poor Emergence'}">
		<template slot="hasHeaders" slot-scope="">
			<label>
			</label>
		</template>
		<template slot="next" slot-scope="{load}">
			<b-button variant="primary" @click.prevent="load">Import CSV</b-button>
		</template>
	</vue-csv-import>
</div>
<div v-else>
	File has been imported, upload to database?
	<b-button variant="primary" @click="importCsv()">Upload</b-button>
</div>
<b-row>
	<b-col>

	</b-col>
</b-row>
<div id="snackbar">{{toastMessage}}</div>
</div>
</template>

<style>
#excel {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	padding: 50px 50px 50px 50px;
}

#snackbar {
	visibility: hidden; /* Hidden by default. Visible on click */
	min-width: 250px; /* Set a default minimum width */
	margin-left: -125px; /* Divide value of min-width by 2 */
	background-color: #333; /* Black background color */
	color: #fff; /* White text color */
	text-align: center; /* Centered text */
	border-radius: 2px; /* Rounded borders */
	padding: 16px; /* Padding */
	position: fixed; /* Sit on top of the screen */
	z-index: 1; /* Add a z-index if needed */
	left: 45%; /* Center the snackbar */
	bottom: 30px; /* 30px from the bottom */
}


#snackbar.show {
	visibility: visible; 
	-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
	animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
	from {bottom: 0; opacity: 0;}
	to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
	from {bottom: 0; opacity: 0;}
	to {bottom: 30px; opacity: 1;}
}

@-webkit-keyframes fadeout {
	from {bottom: 30px; opacity: 1;}
	to {bottom: 0; opacity: 0;}
}

@keyframes fadeout {
	from {bottom: 30px; opacity: 1;}
	to {bottom: 0; opacity: 0;}
}

</style>

<script>
import { shipmentsRef } from '../firebase'
import { batchRef } from '../firebase'
import { butterflyRef } from '../firebase'
export default {
	name: 'shipments',
	data () {
		return {
			file: null,
			start: null,
			end: null,
			shipments: [],
			batches: [],
			butterflies: [],
			shipmentDate: '',
			arrivalDate: '',
			supplier: '',
			species: '',
			commonName: '',
			numberReceived: '',
			toastMessage: '',
			json_data: [],
			parseCsv: null
		}
	},
	firebase: {
		shipments: shipmentsRef,
		batches: batchRef,
		butterflies: butterflyRef
	},
	methods: {
		onChangeStart(event){
			this.start = new Date(event);
			this.generate();
		},
		onChangeEnd(event){
			this.end = new Date(event);
			this.generate();
		},
		generate(){
			if(this.start === null || this.end === null){
				return;
			}
			this.json_data = [];

			for(let i=0; i<this.batches.filter(this.thisUser).length; i++){
				for(let j=0; j<this.shipments.filter(this.thisUser).length; j++){
					if(this.shipments.filter(this.thisUser)[j]['.key']==this.batches.filter(this.thisUser)[i].id){
						var tempDate = new Date(this.shipments.filter(this.thisUser)[j].shipmentDate);
						if(tempDate.getTime()<=this.end.getTime() && tempDate.getTime()>=this.start.getTime()){
							this.json_data.push({
								'Species': this.batches[i].speciesN,
								'Common Name': this.batches[i].commonName,
								'Number Received': this.shipments[j].numberReceived,
								'Supplier': this.shipments[j].supplier,
								'Shipment Date': this.shipments[j].shipmentDate,
								'Arrival Date': this.shipments[j].arrivalDate,
								'Emerged in transit': this.batches[i].emerged,
								'Damaged in transit':this.batches[i].damaged,
								'Diseased': this.batches[i].damaged,
								'Parasites': this.batches[i].parasites,
								'No Emergence': this.batches[i].noEmergence,
								'Poor Emergence': this.batches[i].poor});
						}
					}
				}
			}
		},
		importCsv(){
			this.parseCsv = this.parseCsv.slice().reverse();
			for(let i=0; i<this.parseCsv.length-1; i++){
				var shipment = null;
				if(this.shipments.length>0){
					shipment = shipmentsRef.push({id: this.shipments[this.shipments.length-1].id+1, shipmentDate: this.parseCsv[i]['Shipment Date'], arrivalDate: this.parseCsv[i]['Arrival Date'], supplier: this.parseCsv[i]['Supplier'], numberReceived: this.parseCsv[i]['Number Received'],
						edit:false, accountedFor: this.parseCsv[i]['Number Received'], user: this.getUser()});
				}else {
					shipment = shipmentsRef.push({id: 1, shipmentDate: this.parseCsv[i]['Shipment Date'], arrivalDate: this.parseCsv[i]['Arrival Date'], supplier: this.parseCsv[i]['Supplier'], numberReceived: this.parseCsv[i]['Number Received'],
						edit:false, accountedFor: this.parseCsv[i]['Number Received'],  user: this.getUser()});
				}

				if(this.parseCsv[i]['Number Received'] === ''){
					this.parseCsv[i]['Number Received'] = 0;
				} 

				if(this.parseCsv[i]['Poor Emergence'] === ''){
					this.parseCsv[i]['Poor Emergence'] = 0;
				}

				if(this.parseCsv[i]['No Emergence'] === ''){
					this.parseCsv[i]['No Emergence'] = 0;
				}

				if(this.parseCsv[i]['Emerged in transit'] === ''){
					this.parseCsv[i]['Emerged in transit'] = 0;
				}

				if(this.parseCsv[i]['Damaged in transit'] === ''){
					this.parseCsv[i]['Damaged in transit'] = 0;
				}

				if(this.parseCsv[i]['Diseased'] === ''){
					this.parseCsv[i]['Diseased'] = 0;
				}

				if(this.parseCsv[i]['Parasites'] === ''){
					this.parseCsv[i]['Parasites'] = 0;
				}

				var good = parseInt(this.parseCsv[i]['Number Received']) - parseInt(this.parseCsv[i]['Poor Emergence'])
				-parseInt(this.parseCsv[i]['No Emergence']) - parseInt(this.parseCsv[i]['Emerged in transit']) - parseInt(this.parseCsv[i]['Damaged in transit']) - parseInt(this.parseCsv[i]['Diseased']) - parseInt(this.parseCsv[i]['Parasites']);

				if(this.butterflies.length == 0){
					butterflyRef.push({id: 1, scientificName: this.parseCsv[i]['Species'],
						commonName: this.parseCsv[i]['Common Name'],
						url: '',
						family: '',
						subFamily: '',
						longevity: '',
						hostPlant: '',
						northAmerica: '',
						southAmerica: '',
						europe: '',
						africa: '',
						australia: '',
						antartica: '',
						asia: '',
						unknown: '',
						etymology: '',
						habitat: '',
						lifeHistory: '',
						startMonth: '',
						endMonth: '',
						funFact: '',
						size: '',
						legs: '',
						iridescentTop: '',
						spottedTop: '',
						stripedTop: '',
						veinsTop: '',
						iridescentBottom: '',
						spottedBottom: '',
						stripedBottom: '',
						veinsBottom: '',
						shape: '',
						tail: '',
						antenna: '',
						flower_nectar: '',
						fruit: '',
						resting: '',
						user: this.getUser()
					});
				}else{
					var exists = false;
					for(let j=0; j<this.butterflies.length; j++){
						if(this.butterflies[j].scientificName.toLowerCase() == this.parseCsv[i]['Species'].toLowerCase()){
							exists = true;
							break;
						}
					}
					if(!exists){
						butterflyRef.push({id: this.butterflies[this.butterflies.length-1].id+1, scientificName: this.parseCsv[i]['Species'],
							commonName: this.parseCsv[i]['Common Name'],
							url: '',
							family: '',
							subFamily: '',
							longevity: '',
							hostPlant: '',
							northAmerica: '',
							southAmerica: '',
							europe: '',
							africa: '',
							australia: '',
							antartica: '',
							asia: '',
							unknown: '',
							etymology: '',
							habitat: '',
							lifeHistory: '',
							startMonth: '',
							endMonth: '',
							funFact: '',
							size: '',
							legs: '',
							iridescentTop: '',
							spottedTop: '',
							stripedTop: '',
							veinsTop: '',
							iridescentBottom: '',
							spottedBottom: '',
							stripedBottom: '',
							veinsBottom: '',
							shape: '',
							tail: '',
							antenna: '',
							flower_nectar: '',
							fruit: '',
							resting: '',
							user: this.getUser()
						});					}
					}


					if(this.batches == null){
						batchRef.push({counter: this.batches[this.batches.length-1].counter+1, speciesN: this.parseCsv[i]['Species'], good: good, poor: this.parseCsv[i]['Poor Emergence'], noEmergence: this.parseCsv[i]['No Emergence'],
							diseased: this.parseCsv[i]['Diseased'], parasites: this.parseCsv[i]['Parasites'], emerged: this.parseCsv[i]['Emerged in transit'], damaged: this.parseCsv[i]['Damaged in transit'], released: 0, edit:false, id: shipment.key, commonName: this.parseCsv[i]['Common Name'],
							user: this.getUser() });
					}else{
						batchRef.push({counter: 1, speciesN: this.parseCsv[i]['Species'], good: good, poor: this.parseCsv[i]['Poor Emergence'], noEmergence: this.parseCsv[i]['No Emergence'],
							diseased: this.parseCsv[i]['Diseased'], parasites: this.parseCsv[i]['Parasites'], emerged: this.parseCsv[i]['Emerged in transit'], damaged: this.parseCsv[i]['Damaged in transit'], released: 0, edit:false, id: shipment.key, commonName: this.parseCsv[i]['Common Name'],
							user: this.getUser() });
					}

				}
				this.showSnackBar('Shipments Imported');
			},
			showSnackBar(message){
				this.toastMessage = message;
				var x = document.getElementById("snackbar");
				x.className = "show";
				setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
			},
			getUser(){
				return this.$parent.activeUser?this.$parent.activeUser.name:'';
			},
			thisUser(shipment){
				return (shipment.user == this.getUser() || this.getUser() == 'Reiman Gardens')?shipment:null
			}
		}
	}
	</script>